import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { ContractsDataSource } from '../../model/DataSources/ContractsDataSource';
import { DialogService } from '../../services/dialog.service';
import { ContractService } from '../../services/contract.service';
import { SnackService } from '../../services/snack.service';
import { BaseListComponent } from '../../SharedModule/BaseListComponent/base-list.component';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Contract } from '../../model/Entities/Contract';
import { Filter } from '../../model/Helpers/Filter';
import { Pagination } from '../../model/Helpers/Pagination';
import { SortInfo } from '../../model/Helpers/SortInfo';
import { merge } from 'rxjs/observable/merge';
import { BaseDataSource } from '../../model/DataSources/BaseDataSource';
import { PrintService } from '../../services/print.service';
import { ContractState } from '../../model/Entities/ContractState';
import { BarcodeService } from '../../services/barcode.service';
import { timer } from 'rxjs/observable/timer';
import 'rxjs/add/observable/interval';
import { Subscription } from 'rxjs';
import {TransportService} from '../../services/transport.service';
import {Transport} from '../../model/Entities/Transport';
import {CompleteTransportDialogComponent} from '../../TransportModule/CompleteTransportDialogComponent/completeTransport.dialog.component';
import {User} from '../../model/Entities/User';
import {
    ContractItemsTransferDialogComponent
} from '../../ContractsModule/ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {EshopHideConfirmDialogComponent} from './EshopHideConfirmDialogComponent/eshop-hide-confirm.dialog.component';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseListComponent implements AfterViewInit {
    tableStorageColumns: String[] = ['id', 'customer', 'term', 'deliveryPaymentInfo', 'qrCode'];
    tableColumns: String[] = ['id', 'customer', 'term', 'price', 'deliveryPaymentInfo'];
    eshopTableColumns: String[] = ['id', 'customer', 'term', 'price', 'deliveryPaymentInfo', 'actions'];
    contractStateClass: any = ContractState;
    pickupDataSource: ContractsDataSource;
    storageDataSource: ContractsDataSource;
    eshopDataSource: ContractsDataSource;
    manualDataSource: ContractsDataSource;
    notReturnedDataSource: ContractsDataSource;

    showQrContractId: number = 0;
    dataSubscription: Subscription;
    user: User;

    refreshRate = 30000;

    defaultFilters = {
        date: new Date(),
        // delivery: 'all',
        deployment: 'all',
        direction: 'all'
    };

    protected readonly Transport = Transport;
    protected readonly ContractState = ContractState;
    protected readonly Contract = Contract;
    now: any = new Date();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('eshopSort') eshopSort: MatSort;
    @ViewChild('storageSort') storageSort: MatSort;
    @ViewChild('pickupSort') pickupSort: MatSort;
    @ViewChild('manualSort') manualSort: MatSort;
    @ViewChild('notReturnedSort') notReturnedSort: MatSort;
    public transports: Transport[];
    showQrTransportId: any;

    constructor(private contractService: ContractService,
        public printService: PrintService,
        public barcodeService: BarcodeService,
        public dialogService: DialogService,
        public userService: UserService,
        public transportService: TransportService,
        public snackService: SnackService,
        private router: Router) {
        super();

        this.pageSizeOptions.push(999)
        this.pageSize = 999;

        this.dataSource = new ContractsDataSource(this.contractService);
        this.pickupDataSource = new ContractsDataSource(this.contractService);
        this.storageDataSource = new ContractsDataSource(this.contractService);
        this.manualDataSource = new ContractsDataSource(this.contractService);
        this.eshopDataSource = new ContractsDataSource(this.contractService);
        this.notReturnedDataSource = new ContractsDataSource(this.contractService);
        this.user = this.userService.getLoggedUser();
        this.loadTransport();

    }

    private loadTransport(): void {
        this.transportService.getSimpleList([
            new Filter('user_id', this.userService.getLoggedUser().id),
            new Filter('actual', true),
        ], { expand: 'users,contract,repeatTransport' }).subscribe((transports: Transport[]) => {
            this.transports = transports;
        })
    }

    ngAfterViewInit() {

        this.resetFilters();
        this.prepareDataLoading();

        this.dataSubscription = timer(0, this.refreshRate).subscribe((val) => {
            this.reloadPage();
        });

        // If the user changes the sort order, reset back to the first page.
        if (this.eshopSort) {
            this.eshopSort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        }
        if (this.storageSort) {
            this.storageSort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        }
        if (this.pickupSort) {
            this.pickupSort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        }
        if (this.manualSort) {
            this.manualSort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        }
        if (this.notReturnedSort) {
            this.notReturnedSort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        }
    }

    ngOnDestroy() {
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
    }

    prepareDataLoading(): void {
        if (this.paginator) {
            const sortChanges = [];
            if (this.eshopSort) sortChanges.push(this.eshopSort.sortChange);
            if (this.storageSort) sortChanges.push(this.storageSort.sortChange);
            if (this.pickupSort) sortChanges.push(this.pickupSort.sortChange);
            if (this.manualSort) sortChanges.push(this.manualSort.sortChange);
            if (this.notReturnedSort) sortChanges.push(this.notReturnedSort.sortChange);

            merge(
                this.paginator.page,
                ...sortChanges,
                // Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged(),
                this.dataChangedEventSubject
            ).subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                const f = [];

                // if (this.filters.delivery !== 'all' && this.filters.delivery) {
                //     f.push(new Filter('delivery', this.filters.delivery));
                // }


                /*
                if (this.filters.deployment !== 'all' && this.filters.deployment) {
                    f.push(new Filter('deployment', this.filters.deployment));
                }
                */

                if (this.filters.deployment !== 'all') {
                    f.push(new Filter('deployment', this.filters.deployment));
                }

                switch (this.filters.direction) {
                    case 'out':
                        const fromDate = new Date(this.filters.date ? this.filters.date.getTime() : Date.now());
                        fromDate.setHours(0, 0, 0, 0);
                        // fromDate.setHours(23, 59, 59, 999);
                        f.push(new Filter('dispatchFrom', fromDate.toISOString(), '='));
                        break;
                    case 'in':
                        const toDate = new Date(this.filters.date ? this.filters.date.getTime() : Date.now());
                        toDate.setHours(23, 59, 59, 999);
                        f.push(new Filter('returnTo', toDate.toISOString(), '='));
                        break;
                    default:
                }

                const dashboardDate = new Date(this.filters.date ? this.filters.date.getTime() : Date.now());

                //zapůjčky s dopravou
                const fDelivery = f.slice(0);
                fDelivery.push(new Filter('delivery', true));
                fDelivery.push(new Filter('state', [
                    ContractState.new,
                    ContractState.confirmed,
                    ContractState.dispatched,
                    ContractState.returned,
                    ContractState.prepared,
                    ContractState.picked,
                    ContractState.handed,
                    ContractState.in_dispatch,
                    ContractState.waitingAccept,
                    ContractState.received,
                ]));

                this.dataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.storageSort ? this.storageSort.active : null, this.storageSort ? this.storageSort.direction : null), fDelivery, {
                        expand: 'customer,items,transport,transport',
                        date: dashboardDate.toISOString()
                    })


                //zápůjčky s osobním odběrem
                const fPickup = f.slice(0);
                console.log(fPickup);
                // fPickup.push(new Filter('delivery', false));
                fPickup.push(new Filter('pickup', this.filters.date.toISOString()))
                fPickup.push(new Filter('state', [
                    ContractState.new,
                    ContractState.confirmed,
                    ContractState.dispatched,
                    ContractState.returned,
                    ContractState.prepared,
                    ContractState.picked,
                    ContractState.handed,
                    ContractState.in_dispatch,
                    ContractState.waitingAccept,
                    ContractState.received,
                ]));

                this.pickupDataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.pickupSort ? this.pickupSort.active : null, this.pickupSort ? this.pickupSort.direction : null), fPickup, {
                        expand: 'customer,items,transport',
                        date: dashboardDate.toISOString()
                    });

                //zápůjčky
                const fStorage = f.slice(0);
                // fStorage.push(new Filter('delivery', true));
                fStorage.push(new Filter('storage', this.filters.date.toISOString()))
                fStorage.push(new Filter('state', [
                    ContractState.new,
                    ContractState.confirmed,
                    ContractState.dispatched,
                    ContractState.returned,
                    ContractState.prepared,
                    ContractState.picked,
                    ContractState.handed,
                    ContractState.in_dispatch,
                    ContractState.waitingAccept,
                    ContractState.received,
                ]));

                this.storageDataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.storageSort ? this.storageSort.active : null, this.storageSort ? this.storageSort.direction : null), fStorage, {
                        expand: 'customer,items,transport',
                        date: dashboardDate.toISOString()
                    });


                //manuální zápůjčky
                const fManual = f.slice(0);
                fManual.push(new Filter('manual', true));
                fManual.push(new Filter('manual_approved', false));
                fManual.push(new Filter('state', [
                    ContractState.new,
                    ContractState.confirmed,
                    ContractState.dispatched,
                    ContractState.returned,
                    ContractState.prepared,
                    ContractState.picked,
                    ContractState.handed,
                    ContractState.in_dispatch,
                    ContractState.waitingAccept,
                    ContractState.received,
                ]));

                this.manualDataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.manualSort ? this.manualSort.active : null, this.manualSort ? this.manualSort.direction : null), fManual, {
                        expand: 'customer,items,transport',
                    });

                // zápůjčky z eshopu
                const fEshop = f.slice(0);
                fEshop.push(new Filter('eshop', true));
                fEshop.push(new Filter('hide', false));
                fEshop.push(new Filter('state', ContractState.new));

                this.eshopDataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.eshopSort ? this.eshopSort.active : null, this.eshopSort ? this.eshopSort.direction : null), fEshop, {
                        expand: 'customer,items,transport',
                    });


                //nevrácené zápůjčky
                const fNotReturned = f.slice(0);
                fNotReturned.push(new Filter('state', [ContractState.dispatched]));
                this.notReturnedDataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.notReturnedSort ? this.notReturnedSort.active : null, this.notReturnedSort ? this.notReturnedSort.direction : null), fNotReturned, {
                        expand: 'customer,items,transport',
                        ended: dashboardDate.toISOString()
                    });


            });
        }
    }

    showContractDetail(contract: Contract): void {
        this.router.navigate([`/contract/${contract.id}`]);
    }

    public isToday(date: Date): boolean {
        date = new Date(date);
        return date.getDate() === this.filters.date.getDate()
            && date.getMonth() === this.filters.date.getMonth()
            && date.getFullYear() === this.filters.date.getFullYear();
    }

    changeState(contract: Contract, state: ContractState) {
        this.contractService.update(contract.id, { state: state }).subscribe((c: Contract) => {
            this.snackService.showSuccess(`Stav změněn`);
            this.loadTransport();
        });
    }

    public getFilters(): Filter[] {
        const f = [];

        if (this.filters.date) {
            f.push(new Filter('date', this.filters.date.toISOString()));
        }

        if (this.filters.deployment !== 'all' && this.filters.deployment) {
            f.push(new Filter('deployment', this.filters.deployment));
        }

        if (this.filters.direction !== 'all' && this.filters.direction) {
            f.push(new Filter('direction', this.filters.direction));
        }

        return f;
    }

    public showQr(contract: Contract): void {
        if (this.showQrContractId > 0 && this.showQrContractId === contract.id) {
            this.showQrContractId = 0;
            return;
        }

        this.showQrContractId = contract.id;
    }

    public showQrTransport(transport: Transport): void {
        if (this.showQrTransportId > 0 && this.showQrTransportId === transport.id) {
            this.showQrTransportId = 0;
            return;
        }

        this.showQrTransportId = transport.id;
    }

    public calculateLastEditMinutes(lastEdit) {
        const d1 = new Date(lastEdit).getTime();
        const d2 = new Date().getTime();
        return Math.round((d2 - d1) / 60000); // Can use Math.floor or Math.ceil depends up to you
    }

    completeTransport(transport) {
        if (transport.contract) {
            transport.completePerson = transport.contract.delivery_contact_person;
        }
        transport.completeDatetime = new Date().toISOString().slice(0, 16);
        transport.completeUserId = this.user;

        this.dialogService.showDialog(CompleteTransportDialogComponent, {
            'transport': transport
        }).afterClosed().subscribe((result: any) => {
            if (result) {
                this.transportService.update(result.id, transport).subscribe((t: Transport) => {
                    this.snackService.showSuccess(`Dokončení dopravy uloženo!`);
                    this.loadTransport();
                });
            } else {
                this.loadTransport();
            }
        });
    }

    hideQrTransport() {
        this.showQrTransportId = null;
    }


    public openTransferDialog(direction: any, contract: any): void {
        this.dialogService.showDialog(ContractItemsTransferDialogComponent, {
            'contract': contract,
            'direction': direction
        }, 1000).afterClosed().subscribe((result: any) => {
        });
    }

    getDate(transportFrom: any) {
        return new Date(transportFrom);
    }

    hide(contract: Contract): void {
        this.dialogService.showDialog(EshopHideConfirmDialogComponent, {
            'contract': contract,
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.contractService.update(contract.id, { hide: true }).subscribe((c: Contract) => {
                    this.snackService.showSuccess(`Zápůjčka ${contract.id} byla skryta`);
                    this.reloadPage();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/DashboardModule/DashboardComponent/dashboard.component.ts